import { Grid } from '@mui/material';
import { styles } from '../../styles';
import TableCell from '~/components/ListCardTable/TableCell';
import { FormInput } from '~/components/FormComponents/FormInput';
import { FormDateInput } from '~/components/FormComponents/FormDateInput';

interface INonProfitTableRowProps {
  index: number;
}

export const NonProfitTableRow = ({ index }: INonProfitTableRowProps) => {
  return (
    <Grid container sx={styles.row}>
      <TableCell title="Код ознаки неприбутковості" size={3}>
        <FormInput
          name={`nonProfitDetails.${index}.code`}
          placeholder={'Введіть код ознаки неприбутковості'}
          variant="standard"
          fullWidth
          sx={{
            ...styles.tableInput,
            pt: '14px',
          }}
          inputProps={{
            maxLength: 20,
          }}
        />
      </TableCell>
      <TableCell title="Оберіть дату рішення" size={3}>
        <FormDateInput
          name={`nonProfitDetails.${index}.decisionDate`}
          variant="standard"
          placeholder="Введіть дату рішення"
          sx={{ mt: '14px', '& .MuiInputBase-input': { pl: 2 } }}
        />
      </TableCell>
      <TableCell title="Введіть номер рішення" size={3}>
        <FormInput
          name={`nonProfitDetails.${index}.decisionNumber`}
          placeholder={'Введіть номер рішення'}
          variant="standard"
          fullWidth
          sx={{
            ...styles.tableInput,
            pt: '14px',
          }}
          inputProps={{
            maxLength: 20,
          }}
        />
      </TableCell>
      <TableCell title="Введіть орган реєстрації" size={3}>
        <FormInput
          name={`nonProfitDetails.${index}.registrationAuthority`}
          placeholder={'Введіть орган реєстрації'}
          variant="standard"
          fullWidth
          sx={{
            ...styles.tableInput,
            pt: '14px',
          }}
          inputProps={{
            maxLength: 20,
          }}
        />
      </TableCell>
    </Grid>
  );
};

export default NonProfitTableRow;
